import { Component, AfterViewInit } from '@angular/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import anime from 'animejs/lib/anime.es.js';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements AfterViewInit {
  baseUrl = 'https://minio.macroad.co.id/weave/pictures/company_';

  constructor() { }
  ngOnInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    gsap.set(".weave-title, .vm-title", {
      opacity: -0.4
    });
  }

  ngAfterViewInit(): void {

    gsap.to(".weave-title", {
      x: 0,
      opacity: 1,
      duration: 1.5,
      scrollTrigger:{
        trigger: ".weave-title",
        start: "top 80%",
        end: "top 80%",
        scrub: 1,
        toggleActions:"restart complete none reverse",
        onEnter: () => this.slideUp(".weave-title .text-wrapper"),
      }
    });
    gsap.to(".vm-title", {
      x: 0,
      opacity: 1,
      duration: 1.5,
      scrollTrigger:{
        trigger: ".vm-title",
        start: "top 80%",
        end: "top 80%",
        scrub: 1,
        toggleActions:"restart complete none reverse",
        onEnter: () => this.slideUp(".vm-title .text-wrapper"),
      }
    });
  }

  slideUp(targets: string) {
    anime.timeline({loop: false})
    .add({
      targets,
      translateY: [100, 0],
      easing: 'easeOutExpo',
      duration: 2000,
    })
  }

  // animateWeave() {
  //   gsap.timeline({
  //     scrollTrigger: {
  //       trigger: '#about_weave_content',
  //       start: 'top top',
  //       end: 'bottom bottom',
  //       pin: '#about_weave_logo',
  //       scrub: true,
  //       pinSpacing: true
  //     }
  //   });
  // }
}
